import { render, staticRenderFns } from "./ClientTransferCourse.vue?vue&type=template&id=e753ae52"
import script from "./ClientTransferCourse.vue?vue&type=script&lang=js"
export * from "./ClientTransferCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports